var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-md bg-white shadow-card flex flex-col px-8 py-3"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('h4',{staticClass:"text-xl normal font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"bg-blue-900 rounded-lg flex items-center justify-center"},[_vm._t("icon")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }